










































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LessonsService } from '../../biz/remote/LessonsService';
import { dayjs, DTW_FORMAT_JA_SHORT, DT_FORMAT_INPUT } from '../../../src_server/common/momentExtends';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { Teacher } from 'src_server/entity/generated/Teacher';
import { routeHelper } from '../../utils/routeHelper';
import { getTeacherSuffixInSession } from '../../utils/building_trans';
import { StudentService } from '../../biz/remote/StudentService';
import { Session } from '../../utils/Session';

class GroupByTeacher {
  teacher!: Teacher;
  rows!: LessonDTO[];
}
@Component({
  components: {},
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DTW_FORMAT_JA_SHORT);
    },
    readed: (read: number) => {
      return read === 0 ? '未読' : '既読';
    },
  },
})
export default class AdminShowLessonsPage extends Vue {
  private user_id = '';
  private rows: LessonDTO[] = [];
  private studentNickName = '';

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }
  get title() {
    return `${this.studentNickName}の日報一覧`;
  }

  get model(): GroupByTeacher[] {
    return this.rows
      .sort((a, b) => {
        if (!a.teacher?.user_id) return 0;
        if (!b.teacher?.user_id) return 0;
        return a.teacher.user_id > b.teacher.user_id ? 1 : -1;
      })
      .reduce((prev: GroupByTeacher[], curr) => {
        if (!curr.teacher) throw Error('集約時に先生の情報が取得できませんでした。これは操作ミスではなくバグです。運営にご連絡ください。');
        const foundGroup = prev.find((p) => p.teacher.user_id === curr.teacher?.user_id);
        if (foundGroup) {
          foundGroup.rows.push(curr);
          foundGroup.rows.sort((a, b) => {
            if (!a.lessons.start_dt) return 0;
            if (!b.lessons.start_dt) return 0;
            return a.lessons.start_dt > b.lessons.start_dt ? -1 : 1;
          });
        } else {
          const group = new GroupByTeacher();
          group.teacher = curr.teacher;
          group.rows = [curr];
          prev.push(group);
        }

        return prev;
      }, []);
  }

  /**
   * 一覧を取得
   */
  @Watch('row', { immediate: true })
  async created() {
    this.user_id = this.$route.query.user_id as string;
    if (!this.user_id) {
      await MessageDialog.systemError('ユーザーID', 'レッスン一覧', this.user_id);
      return;
    }
    const sbiz = new StudentService();
    const sResponse = await sbiz.getStudentByUserId(this.user_id);
    if (!sResponse.hasError) {
      this.studentNickName = sResponse.data.student.nickname!;

      const biz = new LessonsService();
      const start = dayjs('2020-01-01');
      const end = start.add(100, 'y');
      const response = await biz.getLessonsStateForStudent(this.user_id, start.format(DT_FORMAT_INPUT), end.format(DT_FORMAT_INPUT), Session.getSessionBuildingId());
      this.rows = response.data;
    }
  }

  async report(row: LessonDTO) {
    if (!row.lessons.class_id) {
      await MessageDialog.systemError('レッスンID', '日報レッスン一覧', row.lessons.class_id);
      return;
    }
    routeHelper(this, 'AdminDailyReportPage', { class_id: `${row.lessons.class_id}` });
  }

  async deleteLesson(row: LessonDTO) {
    const isOK = await MessageDialog.confirm(
      `先生:${row.teacher?.nickname},生徒:${row.student?.nickname}の${dayjs(row.lessons.start_dt).format(DTW_FORMAT_JA_SHORT)}のレッスンをキャンセルします。よろしいですか？`
    );
    if (isOK) {
      const biz = new LessonsService();
      const response = await biz.cancel(row.lessons.class_id!, Session.getSessionBuildingId(), `${dayjs().format(DTW_FORMAT_JA_SHORT)}に、運営によりキャンセル`);
      if (response.hasError) {
        await MessageDialog.alert(`${response.errorDescription}`);
        return;
      }
      this.rows.splice(
        this.rows.findIndex((v) => v.lessons.class_id === row.lessons.class_id),
        1
      );
      await MessageDialog.alert(`レッスンをキャンセルしました。`);
    }
  }
}
